<template>
  <div class="button-help" @click="showModalHelper">
    <div class="mobile-not">
      <img
        v-if="!grayColor"
        src="~~/assets/icons/tik.svg"
        alt="help"
        width="16"
        height="16"
      />
      <img v-else src="~~/assets/icons/tik-gray.png" alt="help" />
      <div class="button-help__main-wrapper">
        <div class="button-help__arrow">
          <svg
            width="15"
            height="18"
            viewBox="0 0 15 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-4.37114e-07 9L15 0.339744L15 17.6603L-4.37114e-07 9Z"
              fill="#F3F3F3"
            />
          </svg>
        </div>
        <div class="button-help__description-wrapper">
          <p class="button-help__description">
            <slot />
          </p>
        </div>
      </div>
    </div>
    <div class="mobile">
      <ModalHelper
        v-if="showModal"
        :class="{ active: showModal }"
        @close="showModal = false"
      >
        <slot />
      </ModalHelper>
    </div>
  </div>
</template>

<script setup>
import ModalHelper from "~/modules/shared/modals/ModalHelper.vue";

const showModal = ref(false);

defineProps({
  grayColor: { type: Boolean, required: false },
});

function showModalHelper() {
  const innerWidthMobile = 1024;

  if (window.innerWidth > innerWidthMobile) {
    showModal.value = false;
  } else {
    showModal.value = true;
    document.documentElement.style.overflow = "hidden";
  }
}
</script>

<style lang="scss" scoped>
.button-help {
  position: relative;

  cursor: pointer;

  &:hover &__main-wrapper {
    opacity: 1;
    visibility: visible;
  }

  &__main-wrapper {
    @include flex-container(column-reverse, null, center);

    position: absolute;
    bottom: 30px;
    right: 80%;

    z-index: 1;

    transform: translateX(50%);

    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;

    @include bigMobile {
      display: none;
    }
  }

  &__description-wrapper {
    width: 275px;

    border-radius: 8px;
    background-color: #f3f3f3;

    padding: 8px;
  }

  &__description {
    @include font(12, 16);
    letter-spacing: 0.02em;
    color: #2b2b2b;
  }

  &__arrow {
    position: absolute;
    bottom: -10px;

    transform: rotateZ(25deg);
  }
}
</style>
